<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4">
        <!-- タイトル -->
        <div class="text-center">
            <h3>{{ $t(textKey + '.title') }}</h3>
        </div>

        <div class="notes">
            <p class="text">
                <!-- メッセージ1 -->
                <span class="text-center" v-html="$t(textKey + '.message1')"></span><br/>
                <!-- メッセージ2 -->
                <span class="text-center" v-html="$t(textKey + '.message2')"></span><br/>
                <span></span><br/>
                <!-- メッセージ3 -->
                <span class="text-center" v-html="$t(textKey + '.message3')"></span><br/>
                <span class="text-center" v-html="$t(textKey + '.message4')"></span><br/>
            </p>
        </div>
        <div class="form-row py-3 justify-content-center">
            <div class="col-md-4">
                <!-- キャンセルボタン -->
                <router-link :to="{ name: 'aube-coin-forthing-status' }" class="text-center">
                    <span class="btn btn-light btn-block">{{ $t(textKey + '.btnBackText') }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'AubeCoinMembershipFeeCampaignComplete',

        components: {
        },

        data() {
            return {
            }
        },

        async created() {

        },

        mounted() {
        },

        methods: {
        },
        computed: {
            textKey() {
                return this.$route.meta.smartPool ? 'aube-coin.is_smart_pool_complete' : 'aube-coin.is_campaign_complete';
            },
        }
    }
</script>

<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

    .card-pricing .list-unstyled li {
        padding: .5rem 0;
        color: #6c757d;
    }
    .card-deck .card {
        flex: inherit;
    }
    .card-deck {
        padding: 0 0 0 10px;
    }
    .text-quantitysent {
        margin-top: 30px;
        margin-bottom: 20px;
    }
    .text-message {
        margin-top: 20px;
    }
    .top {
        margin-top: 20px;
    }
    .text{
        margin-right: 10px;
    }
    .cancelbtn {
        margin-top: 20px !important;
    }
    .notes {
        margin: 16px auto;
        text-align: center;
        display: block;
    }
    .notes .text {
        text-align: left;
        display: inline-block;
    }
    .btn:hover {
        color: #fff !important;
    }
    @media screen and (max-width: 991px) {
        .attention >>> br {
            display: none;
        }
    }
</style>
